
<template>
    <div class="center">
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
      <vs-table>
        <template #thead>
          <vs-tr>
            <vs-th style="width: 5%;">
              
            </vs-th>
            <vs-th  style="width: 20%;">
                Nombre
            </vs-th>
            <vs-th style="width: 20%;">
                Rvoe
            </vs-th>
            <vs-th>
                Periodicidad
            </vs-th>
            <vs-th>
                Nivel Académico
            </vs-th>
            <vs-th>
                Reclutando NI
            </vs-th>
            <vs-th>
                Acciones
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in users"
            :data="tr"
          >
            <vs-td>
                <p class="mb-0">{{ tr.id }}</p>
            </vs-td>
            <vs-td>
                <p class="mb-0">{{ tr.nombre }}</p>
            </vs-td>
            <vs-td>
                <p class="mb-0">{{ tr.revoe }}</p>
            </vs-td>
            <vs-td>
                <p class="mb-0">{{ tr.periodicidad.titulo }}</p>
            </vs-td>
            <vs-td>
                <p class="mb-0">{{ tr.nivel_academico.nivel }}</p>
            </vs-td>
            <vs-td>
                <md-chip v-if="tr.reclutando_nuevo_ingreso == 'si'" class="mb-1 fontMedium mini-chip col-green" ><strong><span class="text-uppercase">{{ tr.reclutando_nuevo_ingreso}}</span> </strong></md-chip>
                <md-chip v-else class="mb-1 fontMedium mini-chip col-yellow" ><strong><span class="text-uppercase">{{ tr.reclutando_nuevo_ingreso}}</span> </strong></md-chip>
            </vs-td>
            <vs-td>
                <md-menu md-align-trigger>
                    <button md-menu-trigger type="button" class="btn btn-sm" style="background: #F8F9F9 !important; color: #797D7F !important;">
                        <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <md-menu-content>
                        <md-menu-item @click="activeEditar = ! activeEditar; selectedRow = tr;">Editar</md-menu-item>
                    </md-menu-content>
                </md-menu>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            Sin información
        </template>
      </vs-table>
      <editar v-model="activeEditar" :row="selectedRow" :instituciones="instituciones" :token="token" @refreshTable="getRefresh"></editar>
    </div>
</template>
<script>
import editar from './modales/editar.vue'
export default {
    props: [
        'users',
        'instituciones',
        'institucion',
        'token'
    ],
    data:() => ({
        search: '',
        activeEditar: false,
        selectedRow: []
    }),
    components:{
        editar
    },
    methods:{
        getRefresh(){
            this.$emit('refreshTable')
        }
    }
}
</script>

<style scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .md-warn{
        background: #ffbc34;
        color: white;
        border-radius: 7px;
    }

    .md-blue{
        background: #5DADE2;
        color: white;
        border-radius: 7px;
    }

    .md-green{
        background: #52BE80;
        color: white;
        border-radius: 7px;
    }
</style>

        

        